<div>
    @if (nav.hasActionIndicators()) {
      <div class="actions">
        <pcp-nav-action-buttons
          [difficultQuestionNumbers]="nav.difficultQuestionNumbers()"
          [assignedDriverscamVideo]="nav.assignedDriverscamVideo()"
          (difficultQuestionIndicatorClicked)="nav.difficultQuestionIndicatorClicked($event)"
          (driverscamAssignmentClicked)="nav.driverscamAssignmentClicked($event)"
        />
      </div>
    }

    <div class="navigation-preview" [class.expanded]="nav.expanded()">
      <!------- first row in the grid: extension slides + their toggle ------->
      <pcp-nav-extension-slides-row
        [slides]="nav.extensionSlides()"
        [previewIdx]="nav.extensionSlidePreviewIdx()"
        [currentSlideIdx]="nav.currentExtensionSlideIndex()"
        [visible]="nav.extensionSlidesNavigationVisible()"
        [previousEnabled]="nav.extensionPreviewPreviousEnabled()"
        [nextEnabled]="nav.extensionPreviewNextEnabled()"
        [visibleCount]="nav.visibleCount"
        (slideClicked)="nav.slideClicked($event)"
        (previousClicked)="nav.extensionPrevious()"
        (nextClicked)="nav.extensionNext()"
        (previewIdxChange)="nav.extensionPreviewIdxChanged($event)"
      />
      <pcp-nav-extension-toggle
        [shown]="nav.showExtensionSlidesPreview()"
        [hasSlides]="nav.hasExtensionSlides()"
        (toggled)="nav.extensionToggled($event)"
      />

      <!------- second row in the grid: basic slides + their toggle ------->
      <pcp-nav-basic-slides-row
        [slides]="nav.basicSlides() ?? []"
        [slideIdx]="nav.basicSlideIdx()"
        [currentSlideIdx]="nav.currentBasicSlideIdx()"
        [visible]="nav.showBasicSlidesPreview()"
        [visibleCount]="nav.visibleCount"
        (slideClicked)="nav.slideClicked($event)"
        (previousClicked)="nav.basicPrevious()"
        (nextClicked)="nav.basicNext()"
        (swiped)="nav.basicSwiped($event)"
      />
      <pcp-nav-basic-toggle
        [shown]="nav.showBasicSlidesPreview()"
        (toggled)="nav.basicToggled($event)"
      />
    </div>
</div>
